import { render } from "./VendorStatusFailedModal.vue?vue&type=template&id=4be7a1ac&scoped=true&ts=true"
import script from "./VendorStatusFailedModal.vue?vue&type=script&lang=ts"
export * from "./VendorStatusFailedModal.vue?vue&type=script&lang=ts"

import "./VendorStatusFailedModal.vue?vue&type=style&index=0&id=4be7a1ac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be7a1ac"]])

export default __exports__